import { proxy } from 'valtio';

// The header's edit button and the dashboard page share this: the page says
// it is editable while it is mounted, the header toggles `editing`.
export const dashboardStore = proxy({
    editable: false,
    editing: false,
});
